import { ReactComponent } from "./ic_recomplete.svg";

interface Props {
  size?: number;
}

const RecompleteIcon: React.FC<Props> = (props) => {
  const iconSize = props.size || 14;
  const iconProps = {
    ...props,
    width: iconSize,
    height: iconSize,
  };
  return <ReactComponent {...iconProps} />;
};

export default RecompleteIcon;
